import { BREAKPOINTS, CLASSES } from "@/scripts/helpers/constants";
import nodeListToArray from "@/scripts/helpers/dom/toArray";
import { clearFocusedElements } from "@/scripts/helpers/library";


export const attachFeaturesSliderHelper = () => {
  const { IS_VISIBLE } = CLASSES;

  $(".js-features-slider-navigation").on("init", function() {
    $(".features-slider__navigation").addClass(IS_VISIBLE);
  });

  $(".js-features-slider-viewport").on("init", function() {
    $(".features-slider__viewport").addClass(IS_VISIBLE);
  });
};

export const initFeaturesSlider = () => {
  const { TABLET, DESKTOP } = BREAKPOINTS;
  const width = $(document).width();
  const sliderMainParent = $(".features-slider");
  const navigation = $(".js-features-slider-navigation");
  const viewport = $(".js-features-slider-viewport");
  const signIllustration = $(".slide__thumb");
  const viewportSlidesImg = nodeListToArray(document.querySelectorAll(".slide .slide__thumb img"));
  const isMobileScreen = width;
  const TRANSITION_SPEED = 200;
  const AUTOPLAY_SPEED = 10000;
  let scrollFlag = false;

  const sliderNavigationConfig = navForClass => {
    return {
      arrows: false,
      asNavFor: navForClass,
      centerMode: false,
      draggable: false,
      focusOnSelect: true,
      infinite: false,
      pauseOnHover: false,
      slidesToShow: 11,
      slidesToScroll: 1,
      speed: TRANSITION_SPEED,
      swipe: false,
      swipeToSlide: true,
      variableWidth: true
    };
  };

  const sliderViewportConfig = navForClass => {
    return {
      arrows: false,
      asNavFor: navForClass,
      autoplaySpeed: AUTOPLAY_SPEED,
      focusOnSelect: true,
      infinite: false,
      pauseOnHover: false,
      speed: TRANSITION_SPEED,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      mobileFirst: true,
      fade: true,
      dots: false,
      infinite: true,
      swipeToSlide: false
    };
  };

  viewport.on("afterChange", function () {
    signIllustration.css("display", "block");
  });
  viewport.on("beforeChange", function () {
    signIllustration.css("display", "none");
  });

  const switchToSlickLazyLoad = img => {
    img.classList.remove("lazy-img");
    img.removeAttribute("data-lazy-src");
    img.removeAttribute("data-lazy-srcset");
  };

  const switchToVanillaLazyLoad = img => {
    img.removeAttribute("data-lazy");
  };

  isMobileScreen
    ? viewportSlidesImg.forEach(img => switchToSlickLazyLoad(img))
    : viewportSlidesImg.forEach(img => switchToVanillaLazyLoad(img));

  navigation.not(".slick-initialized").slick(sliderNavigationConfig(viewport));
  viewport.not(".slick-initialized").slick(sliderViewportConfig(navigation));

  const navigationSlides = nodeListToArray(document.querySelectorAll(".js-features-slider-navigation .slick-slide"));
  const navigationSlidesElements = nodeListToArray(document.querySelectorAll(".slide-navigation"));
  const scrollToActiveSlide = slide => {
    const sliderTrack = document.querySelector(".js-features-slider-navigation .slick-track");
    const scrollTo = navigationSlides[slide].offsetLeft;

    sliderTrack.scrollTo({
      top: 0,
      left: scrollTo,
      behavior: "smooth"
    });
  };

  navigationSlides.forEach((slide, index) => {
    slide.addEventListener("keydown", e => {
      if (e.keyCode === 13) {
        viewport.slick("slickGoTo", index);
        scrollToActiveSlide(index);
      }
    });

    if (slide.classList.contains("slick-current")) {
      const currentSlideElement = slide.querySelector(".slide-navigation");
      const currentSlideElementHref = currentSlideElement.getAttribute("data-href");

      currentSlideElement.setAttribute("href", currentSlideElementHref);
    }
  });

  navigation.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
    const width = $(document).width();
    const currentSlideElement = navigationSlides[nextSlide].querySelector(".slide-navigation");
    const currentSlideElementHref = currentSlideElement.getAttribute("data-href");
    const isHorizontalScrollMarkup = width < DESKTOP;
    clearFocusedElements();

    if (currentSlide === nextSlide) return;

    navigationSlidesElements.forEach(slideEl => {
      slideEl.removeAttribute("href");
      slideEl.setAttribute("aria-selected", false);
    });
    currentSlideElement.setAttribute("aria-selected", true);
    setTimeout(() => currentSlideElement.setAttribute("href", currentSlideElementHref), 0);

    if (isHorizontalScrollMarkup) scrollToActiveSlide(nextSlide);
  });

  const initAutoplay = () => {
    if ($(window).width() < TABLET) return;
  };

  window.addEventListener("load", () => initAutoplay());
  window.addEventListener("scroll", () => initAutoplay());
};
